import styled from "styled-components";

const SliderStyled = styled.div`
  width: 100%;
  height: 100%;

  .slick-list,
  .slick-slider,
  .slick-track {
    display: block;
    position: relative;
    height: 100%;
  }

  .slick-loading .slick-slide,
  .slick-loading .slick-track {
    visibility: hidden;
  }

  .slick-slider {
    user-select: none;
    -webkit-touch-callout: none;
    touch-action: pan-y;
    -webkit-tap-highlight-color: transparent;
  }
  .slick-list {
    overflow: hidden;
    margin: 0;
    padding: 0;
  }

  .slick-list:focus {
    outline: 0;
  }

  .slick-list.dragging {
    cursor: pointer;
    cursor: hand;
  }

  .slick-slider .slick-list,
  .slick-slider .slick-track {
    transform: translate3d(0, 0, 0);
  }

  .slick-track {
    top: 0;
    left: 0;
  }

  .slick-track::after,
  .slick-track::before {
    display: table;
    content: "";
  }

  .slick-track::after {
    clear: both;
  }

  .slick-slide {
    display: none;
    float: left;
    height: 100%;
    min-height: 1px;
  }

  [dir="rtl"] .slick-slide {
    float: right;
  }

  .slick-slide > div {
    height: 100%;
  }

  .slick-slide.slick-loading img {
    display: none;
  }

  .slick-slide.dragging img {
    pointer-events: none;
  }

  .slick-initialized .slick-slide {
    display: block;
  }

  .slick-vertical .slick-slide {
    display: block;
    height: auto;
    border: 1px solid transparent;
  }

  /* ----------------- Dots ----------------- */

  .slick-dots {
    display: flex !important;
    justify-content: center;
    align-items: center;
    position: absolute;
    width: 100%;
    margin: 100px 0 0;
    padding: 0;
    list-style: none;
  }

  .slick-dots li {
    position: relative;
    width: 11px;
    height: 11px;
    margin: 0;
    padding: 0;
    cursor: pointer;

    &:not(:last-of-type) {
      margin-right: 11px;
    }
  }

  .slick-dots li button {
    display: block;
    width: 100%;
    height: 100%;
    color: transparent;
    font-size: 0;
    line-height: 0;
    outline: 0;
  }

  .slick-dots li button:focus,
  .slick-dots li button:hover {
    outline: 0;
  }

  .slick-dots li button:focus:before,
  .slick-dots li button:hover:before {
    opacity: 1;
  }

  .slick-dots li button:before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #b2b2b2;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.41);
    border-radius: 20px;
    opacity: 0.18;
  }

  .slick-dots li.slick-active button:before {
    background-color: #f3f3f3;
    opacity: 1;
  }

  /* ----------------- Arrows ----------------- */

  .slick-arrow.slick-hidden {
    display: none;
  }

  .slick-next,
  .slick-prev {
    display: block;
    position: absolute;
    padding: 0;
    color: transparent;
    font-size: 0;
    line-height: 0;
    z-index: 1;

    @media (max-width: 1023px) {
      bottom: 30px;
      width: 40px;
      height: 40px;
    }

    @media (min-width: 1024px) {
      top: 50%;
      width: 51px;
      height: 51px;
      transform: translateY(-50%);
    }
  }

  .slick-next.slick-disabled,
  .slick-prev.slick-disabled {
    cursor: initial;
  }

  .slick-next:focus,
  .slick-next:hover,
  .slick-prev:focus,
  .slick-prev:hover {
    outline: 0;
  }

  .slick-next:focus::before,
  .slick-next:hover::before,
  .slick-prev:focus::before,
  .slick-prev:hover::before {
    opacity: 1;
  }

  .slick-next.slick-disabled::before,
  .slick-prev.slick-disabled::before {
    opacity: 0.5;
  }

  .slick-next::before,
  .slick-prev::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-repeat: no-repeat;
    background-position: center;

    @media (max-width: 1023px) {
      background-size: 40px;
    }

    @media (min-width: 1024px) {
      background-size: 51px;
    }
  }

  .slick-prev {
    @media (max-width: 1023px) {
      left: 0;
    }

    @media (min-width: 1024px) {
      left: -40px;
    }
  }

  .slick-prev::before {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 51 51'%3E%3Cpath fill='%23c3c3c3' d='M25.522 51.043c-19.635-.006-31.9-21.266-22.077-38.267A25.504 25.504 0 0 1 15.596 2.043C33.687-5.598 53.265 9.21 50.837 28.697a25.51 25.51 0 0 1-15.389 20.346 25.329 25.329 0 0 1-9.926 2Zm0-50C6.657 1.057-5.119 21.488 4.326 37.819a24.501 24.501 0 0 0 11.66 10.299c17.379 7.341 36.187-6.883 33.856-25.604A24.506 24.506 0 0 0 35.059 2.968a24.353 24.353 0 0 0-9.537-1.925Zm-1.451 24.465 4.743 4.74a.891.891 0 0 1 0 1.265.9.9 0 0 1-1.269 0l-5.375-5.371a.895.895 0 0 1-.026-1.235l5.4-5.408a.9.9 0 0 1 1.269 1.265Z'/%3E%3C/svg%3E");
  }

  .slick-next {
    @media (max-width: 1023px) {
      right: 0;
    }

    @media (min-width: 1024px) {
      right: -40px;
    }
  }

  .slick-next::before {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 51 51'%3E%3Cpath fill='%23c3c3c3' d='M25.506-.005c19.635.006 31.9 21.266 22.077 38.267a25.504 25.504 0 0 1-12.151 10.733C17.341 56.636-2.237 41.828.191 22.341A25.51 25.51 0 0 1 15.58 1.995a25.329 25.329 0 0 1 9.926-2Zm0 50c18.865-.014 30.641-20.445 21.196-36.776A24.501 24.501 0 0 0 35.042 2.92C17.663-4.421-1.145 9.803 1.186 28.524A24.506 24.506 0 0 0 15.969 48.07a24.353 24.353 0 0 0 9.537 1.925Zm1.451-24.465-4.743-4.74a.891.891 0 0 1 0-1.265.9.9 0 0 1 1.269 0l5.375 5.371a.895.895 0 0 1 .026 1.235l-5.4 5.408a.9.9 0 0 1-1.269-1.265l4.742-4.744Z'/%3E%3C/svg%3E");
  }

  .slick-dotted.slick-slider {
    margin-bottom: 30px;
  }
`;

export default SliderStyled;
